<template>
  <div>
    <b-carousel
      id="carousel-1"
      ref="myCarousel"
      v-model="slide"
      :interval="4000"
      indicators
      fade
      img-width="100%"
      class="banner-section"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
    >
      <!-- Text slides with image -->
      <b-carousel-slide :img-src="require('../assets/banner_mac.jpeg')">
        <div class="imgtext">
          <h2 class="animate__animated fadeInRight">
            三资管理系统，助力苏州吴中区农村信息化建设，踏上新台阶
          </h2>
          <p class="animate__animated fadeInRight delays">经营破局 数据创赢</p>
          <p class="animate__animated fadeInRight delays">健康小微 成长最美</p>
          <div class="button-group animate__animated fadeInRight delays2">
            <router-link to="/successcase/assets">查看详情</router-link>
          </div>
        </div>
      </b-carousel-slide>
      <b-carousel-slide img-src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202112/142240130osz.png">
        <div class="imgtext">
          <h2 class="animate__animated fadeInRight">
            金蝶云·苍穹
          </h2>
          <p class="animate__animated fadeInRight delays">金蝶云·星瀚SaaS</p>
          <p class="animate__animated fadeInRight delays">新一代企业级SaaS平台</p>
          <div class="button-group animate__animated fadeInRight delays2">
            <router-link to="/cosmic">查看详情</router-link>
          </div>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'MyCarousel',
  props: {
    imgarray: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      showIndicator: true,
      focus: [
        {
          img: ''
        }
      ]
    }
  },
  watch: {
    imgarray: {
      handler(val, oldVal) {
        // console.log(val)
        // console.log('收到收到收到')
      },
      immediate: true
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    prev() {
      this.$refs.myCarousel.prev()
    },
    next() {
      this.$refs.myCarousel.next()
    },
    jump(index) {
      this.$refs.myCarousel.setSlide(index)
    }
  }
}
</script>
<style scoped>
.banner-section::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    background: rgba(0,4,44,.6);
    top: 0;
    left: 0;
    z-index: -1;
}
#img {
  display: flex;
}

.delays {
  animation-delay: 0.3s;
  animation-duration: 1s;
}

.delays2 {
  animation-delay: 0.7s;
  animation-duration: 1s;
}

.delays3 {
  animation-delay: 1.2s;
  animation-duration: 1s;
}

.imgtext h2 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 14px;
}

.imgtext p {
    font-size: 16px;
    line-height: 30px;
}

.imgtext {
    text-align: left;
    margin-top: -280px;
    position:absolute;
    text-shadow: 1px 1px #484848;
}

.button-group a {
    display: inline-block;
    width: 140px;
    height: 48px;
    line-height: 48px;
    border-radius: 5px;
    overflow: hidden;
    font-size: 16px;
    text-align: center;
    margin-right: 10px;
    color: #fff
    /* position: relative; */
}

.button-group a:first-child {
    background: linear-gradient( 135deg,#0068dd,#00aeee);
}

.button-group a:last-child {
    border: 1px solid #fff;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(120px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  animation-name: fadeInRight;
}

.list {
    display: inline-block;
    list-style: none;
    margin: 20px;
    padding-left: 0;
    /* 去掉 inline-block 产生的块间隙 */
    font-size: 0;
}

.listItem {
    display: inline-block;
    padding: 20px 30px;
    font-size: 15px;
    font-weight: 700;
    color: #969696;
    position: relative;
    /* border-bottom:dotted 10px #000; */
}

.listItem a {
    cursor: pointer;
    outline: 0;
    text-decoration: none;
}

.listItem a:hover {
    color: #646464;
}

.listItem:hover:after {
    opacity: 1;
    transform: translate(-50%) scaleX(1);
}

.listItem:after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -5px;
    width: 80%;
    opacity: 0;
    border-bottom: 2px solid #646464;
    transform: translate(-50%) scaleX(0);
    transition: .5s ease-in-out;
}

</style>
<style>
.w-100  {
    width: 100%;
    height: 460px !important;
    object-fit: cover!important;
}

.carousel-indicators{
  bottom: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/carousel.vue